module.exports = __webpack_public_path__ + "static/media/02.fb34af3d.png";